import WebLayout from './SeparatorWithTextLayout.web';
import MobileLayout from './SeparatorWithTextLayout.mobile';
import { isReactNative }   from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;